import React, {useEffect, useState} from "react";
import "./coaching.scss";
import ListingComp from "./ListingComp";
import {UserAuthService} from "../../../services/user-auth-api.service";
import {CoachingClientLisitng} from "../../../services/coaching.service";
import {Dropdown, Pagination} from "antd";
import ClientListSkeleton from "../../skeletons/coaching/ClientListSkeleton";
import NoRecord from "../../../components/dashboard/no-record/NoRecord";
import {useNavigate} from "react-router-dom";
import {DropDownCheck, RightIconGradient} from "../../../../assets/icons/defaultIcons";

const Dashcoaching = () => {
  let navigate = useNavigate();
  // let authUser = UserAuthService?.getAuthUser();
  const [ClientListing, setClientListing] = useState([]);
  const [current, setCurrent] = useState(1);
  const [totalRow, setTotalRow] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [loading, setLoading] = useState(true);
  const [authUser, setAuthUser] = useState('')
  const [selectedItem, setSelectedItem] = useState('All')

  async function GetProfileData() {
    setLoading(true)
    const response = await UserAuthService.getProfileData();
    if (response?.data?.data?.status) {
      setLoading(false)
      setAuthUser(response.data?.data?.data?.user)
      if (!response.data?.data?.data?.user?.isCoach){
        navigate('/')
      }
    }
  }


  useEffect(() => {
    GetProfileData();
  }, []);

  const HandleClientList = async () => {
    if (!authUser) return; // Only proceed if authUser is available
    let param = {
      page: current,
      limit: 10,
    };
    
    // Add status filter if not "All"
    if (selectedItem !== "All") {
      param.status = selectedItem.toLowerCase();
    }
    
    let res = await CoachingClientLisitng(authUser?._id, param);
    if (res?.data?.data?.data?.clients) {
      setClientListing(res?.data?.data?.data?.clients);
      setTotalRow(res?.data?.data?.data?.pagination?.totalRecords);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    setIsLoading(true);
    HandleClientList();
  }, [current, authUser, selectedItem]);

  const onChange = (page) => {
    setCurrent(page);
  };

  const items = [
    { key: "1", label: (<a onClick={() => setSelectedItem("All")} className="d-flex justify-content-between w-100">All {selectedItem === "All" && <DropDownCheck />}</a>) },
    { key: "2", label: (<a onClick={() => setSelectedItem("Active")} className="d-flex justify-content-between w-100">Active {selectedItem === "Active" && <DropDownCheck />}</a>) },
    { key: "3", label: (<a onClick={() => setSelectedItem("Inactive")} className="d-flex justify-content-between w-100">Inactive {selectedItem === "Inactive" && <DropDownCheck />}</a>) },
  ];


  if (isLoading) {
    return (
        <>
          {[0, 1, 2, 3]?.map((v, i) => (
              <ClientListSkeleton key={i}/>
          ))}
        </>
    );
  }

  return (
      <div className="main_div_coaching">
        <div className="header">
          <h3>Clients List
            <span>
                        <Dropdown menu={{ items }} placement="bottomLeft" trigger={["click"]} arrow>
                          <span className="coaching-dropdown">
                            {selectedItem}
                            <RightIconGradient style={{ marginRight: '5px' }} />
                            </span>
                        </Dropdown>
          </span>
          </h3>
        </div>
        <div className="listing_content">
          {ClientListing &&
          ClientListing?.map((v, i) => {
            return (
                <div className="inner_lisiting">
                  <ListingComp Data={v} />
                </div>
            );
          })}
          {
            ClientListing.length === 0 &&
            <NoRecord/>
          }
        </div>
        {
          ClientListing.length > 0 &&
          <div>
            <Pagination current={current} onChange={onChange} total={totalRow} />
          </div>
        }

      </div>
  );
};

export default Dashcoaching;
